module.exports = __webpack_public_path__ + "images/category_lp/common/icon-voice-man-20@2x_63622d72b408d8eef30fe2ab629f1390.png";